import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../api';
import { useAuth, useBrand } from '../context/AppContext';
import { Spinner } from '../components/UI';

export default function LoginScreen() {
  const navigate  = useNavigate();
  const { refresh, applyCompanyBrand } = useAuth();
  const brand     = useBrand();
  const [pin, setPin]         = useState('');
  const [error, setError]     = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!pin) return;
    setLoading(true); setError('');
    try {
      const { data } = await login(pin);
      if (data.company) applyCompanyBrand(data.company);
      await refresh();
      navigate('/products');
    } catch (err) {
      setError(err.response?.data?.error || 'Invalid PIN. Please try again.');
      setPin('');
    } finally { setLoading(false); }
  };

  return (
    <div className="login-wrap">
      <div className="login-card">
        {brand.brandLogo
          ? <img src={brand.brandLogo} alt={brand.brandName} style={{ height:56, marginBottom:14, objectFit:'contain' }} />
          : <div className="login-logo">{brand.brandName}</div>
        }
        <div className="login-sub">Photographer Order Portal</div>
        <form onSubmit={handleSubmit} autoComplete="off">
          <div className="field">
            <label className="label">Group PIN</label>
            <input
              className={`input pin-input ${error ? 'input-error' : ''}`}
              type="password"
              inputMode="numeric"
              placeholder="••••"
              value={pin}
              autoComplete="new-password"
              onChange={e => { setPin(e.target.value); setError(''); }}
              autoFocus
              maxLength={12}
            />
          </div>
          {error && <div style={{ color:'var(--danger)', fontSize:13, marginBottom:12 }}>{error}</div>}
          <button className="btn btn-primary btn-full btn-lg" type="submit" disabled={!pin || loading}>
            {loading ? <Spinner size={18} /> : 'Sign in'}
          </button>
        </form>
        <div style={{ marginTop:20, fontSize:12, color:'var(--text3)' }}>
          Contact your administrator if you don't have a PIN
        </div>
      </div>
    </div>
  );
}
